function objectFitPolyfill(){
  this.init = function(){
    this.images = document.querySelectorAll('img[data-object-fit]');
    this.isIE = this.detectIE();
    this.bindEvents();
  }

  this.check = function(){
    this.images = document.querySelectorAll('img[data-object-fit]');
    if(this.isIE){
      for(var i = 0; i < this.images.length; i++){
        var width = 0;
        var height = 0;
        var src = '';

        $(this.images[i]).parent().hide();

        width = $(this.images[i]).css('width');
        height = $(this.images[i]).css('height');
        src = $(this.images[i]).attr('src');

        $(this.images[i]).parent().show();

        $(this.images[i]).wrap('<div class="object-fit" style="background: url('+src+') no-repeat center center; background-size:cover; width: '+ width +'; height: '+ height +'; display: inline-block" data-object-fit></div>');

        $(this.images[i]).removeAttr('data-object-fit');
        $(this.images[i]).css({'visibility':'hidden', 'min-width':'100%', 'min-height':'100%'});
      }
    }
  }

  this.detectIE = function(){
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    var edge = ua.indexOf('Edge/');
    var trident = ua.indexOf('Trident/');
    if (msie > 0 || trident > 0 || edge > 0) {
      return true;
    }
  }

  this.bindEvents = function(){
    var self = this;
    $(document).ready(function(){
      self.check();
    })
  }

  this.init();
}

export default objectFitPolyfill;


// WEBPACK FOOTER //
// src/js/bundle/objectFitPolyfill.js